import React from 'react';
// COMPONENTS
import Col from 'components/common/Col';
import Row from 'components/common/Row';
import TextEditorInput from 'components/inputs/TextEditorInput';
import TextEditorHelpers from 'lib/helpers/TextEditorHelpers';
import CurrencyHelpers from 'lib/helpers/CurrencyHelpers';

class ContractTerms extends React.PureComponent {
  componentDidMount() {
    this.setComponent();
  }

  getTermsHTML = contractType => {
    const contract = this.props.contract;
    let terms = contract.termsHTML;
    const currencySymbol = CurrencyHelpers.getCurrencySymbol(contract.currency);

    let termsOptions = {
      finalPaymentDueDate: contract.finalPaymentDueDate,
      depositAmount: contract.depositAmount,
      client: contract.client,
      sessionDate: contract.sessionDate,
      currencySymbol,
      organization: {
        title: (contract.organization && contract.organization.title) || '',
        city: (contract.organization && contract.organization.city) || '',
        state: (contract.organization && contract.organization.state) || '',
        country: (contract.organization && contract.organization.country) || '',
      },
    };

    if (!contractType) {
      throw new Error(404, 'Contract type is missing');
    }

    switch (contractType) {
    case 'Wedding':
      terms = TextEditorHelpers.getWeddingTermsHTML(termsOptions);
      break;
    case 'Portrait':
      terms = TextEditorHelpers.getPortraitTermsHTML(termsOptions);
      break;
    case 'Event':
      terms = TextEditorHelpers.getEventTermsHTML(termsOptions);
      break;
    case 'Newborn':
      terms = TextEditorHelpers.getNewbornTermsHTML(termsOptions);
      break;
    case 'Boudoir':
      terms = TextEditorHelpers.getBoudoirTermsHTML(termsOptions);
      break;
    case 'Real Estate':
      terms = TextEditorHelpers.getRealEstateTermsHTML(termsOptions);
      break;
    default:
      throw new Error(404, 'Unknown contract type');
    }

    return terms;
  };

  setComponent = () => {
    let termsHTML = this.getTermsHTML(this.props.contract.contractType);
    // only set default terms if none exist
    if (!this.props.contract.termsHTML) {
      this.props.onChange({ termsHTML });
    }
  };

  render() {
    return (
      <div>
        <TextEditorInput
          value={this.props.contract.termsHTML}
          onChange={termsHTML => this.props.onChange({ termsHTML })}
        />
      </div>
    );
  }
}

export default ContractTerms;



// WEBPACK FOOTER //
// ./src/routes/contract-draft/ContractTerms/index.js